<template>
  <b-table
    id="tbMinuta"
    :no-border-collapse="false"
    striped hover bordered responsive small
    :items="resultado"
    :fields="fields"
    :busy="configTable.load"
    :perPage="configTable.perPage"
    :currentPage="configTable.currentPage" 
    :sort-by="configTable.sortField"
    :sort-desc="false"
    show-empty
    class="mb-0"
    head-variant="light"
  >
    <div slot="table-busy" class="text-center text-primary my-2">
      <b-spinner class="align-middle"></b-spinner>
      <strong> Carregando...</strong>
    </div>
    <template slot="empty">
      <p class="my-auto">Nenhum modelo encontrado.</p>
    </template>

    <template slot="selecao" slot-scope="row">
      <b-form-checkbox
        v-model="row.item.selecao"
        name="checkbox-1"
        :unchecked-value="false"
        :value="true"
        @change="selecionar"
      >
      </b-form-checkbox>
    </template>

    <template slot="descricao" slot-scope="row">
      <div>
        {{ row.item.descricao }}
      </div>
    </template>

    <template slot="movimento" slot-scope="row">
      <div>
        {{ row.item.descricaoMovimento }}
      </div>
    </template>

    <template slot="tipoTramitacao" slot-scope="row">
      <div>
        {{ row.item.textoTipoTramitacao }}
      </div>
    </template>

    <template slot="tipoDocumento" slot-scope="row">
      <div>
        {{ getTpoDocumentoEnum(row.item.tipoDocumento) }}
      </div>
    </template>

    <template slot="indAtivo" slot-scope="row">
      <div>
        {{ row.item.indAtivo ? 'Ativo' : 'Inativo' }}
      </div>
    </template>

  </b-table>
</template>

<script>

const TipoDocumentoEnum = Object.freeze({
  APELACAO: "Apelação",
  CONTESTACAO: "Contestação",
  EMBARGOS: "Embargos de Declaração",
  PETICAO: "Petição Outras"
})

export default {
  props: ["resultado", "fields", "configTable"],
  watch: {
    currentPage() {
      this.$emit("consultar");
    },
    resultado() {
      this.$emit("selecionar", []);
    }
  },
  computed: {
    currentPage() {
      return this.configTable.currentPage;
    },
  },
  methods: {
    getTpoDocumentoEnum(val) {
      return TipoDocumentoEnum[val];
    },
    selecionar() {
      this.$nextTick(() => {
        const selecionados = this.resultado.filter(i => i.selecao);
        this.$emit("selecionar", selecionados);
      });
    },
  },
};
</script>

<style scoped>
.no-line {
  white-space: nowrap;
}
</style>
